import { SeriesCard } from "../../common/SeriesCard.js";
import { HistoryService } from "../../../services/history.service.js";
import { ContentService } from "../../../services/content.service.js";
import { locale } from "../../../services/LocaleService.js";

export const ContinueReadingSection = async (userData) => {
    const container = document.createElement('div');

    if (!userData || !userData.uid) return container; // Need UID for subcollection

    // Fetch from Subcollection
    // [FIX] Guard against invalid user data
    if (!userData || !userData.uid) return container;

    // Fetch from Subcollection
    // HistoryService.getHistory returns { items: [], lastVisible: ... }
    const { items: historyItems } = await HistoryService.getHistory(userData.uid, 20);
    if (!historyItems || historyItems.length === 0) return container;

    // Fetch fresh series data
    const seriesIds = historyItems.map(h => h.seriesId).filter(Boolean);
    const uniqueIds = [...new Set(seriesIds)];
    const freshSeriesList = await ContentService.getSeriesByIds(uniqueIds);

    const safeItems = historyItems
        .filter(item => item.seriesId && item.lastEpisodeId)
        .map(item => {
            const fresh = freshSeriesList.find(s => s.id === item.seriesId);

            // [FIX] Strict Filtering: Remove deleted OR missing title (corrupted)
            if (!fresh || fresh.status === 'deleted' || !fresh.title) return null;

            const displayImage = fresh.coverImage || fresh.thumbnail;
            const title = fresh.title;
            const type = fresh.type || fresh.contentType;

            // Pass marketing data if injected into fresh series (handled by controller/service ideally)
            // But here we rely on what we have. 
            // In the new architecture, Controller (home.js) should inject marketing into ContentService cache or similar.
            // For now, let's allow SeriesCard to handle what it has.

            // **CRITICAL**: The original code handled image proxy for 'pstatic/daumcdn'.
            // We must preserve this.

            return {
                ...item,
                displayImage,
                title,
                type,
                _marketing: fresh?._marketing // Pass through if available
            };
        })
        .filter(Boolean)
        .slice(0, 10);

    if (safeItems.length === 0) return container;

    container.className = "mb-10 animate-fade-in";
    container.innerHTML = `
        <div class="flex items-center gap-2 mb-4 px-1 md:px-0">
            <span class="material-symbols-outlined text-indigo-600">history</span>
            <h2 class="text-xl font-bold text-gray-900">${locale.t('main.continue_reading')}</h2>
        </div>
    `;

    const scrollDiv = document.createElement('div');
    scrollDiv.className = "flex gap-4 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0 scroll-smooth snap-x";

    safeItems.forEach(item => {
        // Image Proxy Logic
        let img = item.displayImage;
        if (img && (img.includes('pstatic') || img.includes('daumcdn'))) {
            img = "https://wsrv.nl/?url=" + encodeURIComponent(img) + "&w=300&output=webp";
        }

        const seriesData = {
            id: item.seriesId,
            title: item.title,
            coverImage: img,
            authorName: 'Last Read',
            type: item.type,
            // 19+ Badge Data
            isAdult: item.isAdult, // Should come from fresh data
            isAI: item.isAI,       // Should come from fresh data
            _marketing: item._marketing // Event Data
        };

        // Merge fresh data props for badges if available
        const fresh = freshSeriesList.find(s => s.id === item.seriesId);
        if (fresh) {
            seriesData.isAdult = fresh.isAdult;
            seriesData.isAI = fresh.isAI;
            seriesData.ageLimit = fresh.ageLimit; // [FIX] Required for Badge
        }

        const card = SeriesCard(seriesData, {
            onClick: () => {
                const link = item.type === 'webnovel' || item.type === 'novel'
                    ? `/webnovel/${item.seriesId}/${item.lastEpisodeId}`
                    : `/series/${item.seriesId}/episode/${item.lastEpisodeId}`;
                window.router.navigate(link);
            },
            overlayStats: false,
            marketing: item._marketing
        });

        card.className = "flex-shrink-0 w-32 md:w-40 snap-start " + card.className;

        // "Last Read" Overlay
        const overlay = document.createElement('div');
        overlay.className = "absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 to-transparent p-2 pt-6 pointer-events-none rounded-b-xl";
        overlay.innerHTML = `<div class="text-[10px] text-indigo-200 font-bold mb-0.5">Last Read</div>`;
        card.querySelector('.relative').appendChild(overlay);

        scrollDiv.appendChild(card);
    });

    container.appendChild(scrollDiv);

    return container;
};
